import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }

import { Voucher } from '@/types';
    import { computed } from 'vue';
    import HoverInfo from '@/components/HoverInfo.vue';
    import { useI18n } from 'vue-i18n';
    import { BrainCircuit, CreditCard, Undo, Waypoints } from 'lucide-vue-next';

    interface Props {
        voucher: Voucher;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherTableAssignedTo',
  props: {
    voucher: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const assigneeNames = computed(() => {
        const employeeNames = (props.voucher.assigned ?? []).map((assigned) => assigned.full_name);
        const userNames = (props.voucher.assigned_users ?? []).map((assignedUser) => assignedUser.name);

        return [...employeeNames, ...userNames].filter(Boolean).join(', ');
    });

    const icon = computed(() => {
        if (props.voucher.assigned_by === 'credit_card') {
            return CreditCard;
        }
        if (props.voucher.assigned_by === 'transaction') {
            return Waypoints;
        }
        if (props.voucher.assigned_by === 'api') {
            return BrainCircuit;
        }
        if (props.voucher.assigned_by === 'fallback') {
            return Undo;
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(_toDisplayString(assigneeNames.value) + " ", 1),
    (_ctx.voucher.assigned_by)
      ? (_openBlock(), _createBlock(HoverInfo, {
          key: 0,
          content: _unref(t)('vouchers.assigned_by.' + _ctx.voucher.assigned_by)
        }, {
          icon: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), { class: "text-secondary size-5 shrink-0" }))
          ]),
          _: 1
        }, 8, ["content"]))
      : _createCommentVNode("", true)
  ]))
}
}

})